/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Note/view.blocks to change it.
import * as fromData from 'Simple/Data'
import NoteTextArea from 'DesignSystem/NoteTextArea/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Note({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Note/Content/Edit/Content/Note",
  onChange,
  isSubmitting
  
}) {
let editorNoteValueData = fromData.useDataValue({ viewPath,
context: 'editor',
path: 'note',
})
let editorNoteChangeData = fromData.useDataChange({ viewPath,
context: 'editor',
path: 'note',
})
let editorNoteIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'editor',
})
  return (<React.Fragment
>
<NoteTextArea
  viewPath={`${viewPath}/NoteTextArea`}
 data="editor.note"
 value={editorNoteValueData}
 onChange={editorNoteChangeData}
 disabled={editorNoteIsSubmittingData}
 templateTags="appointment"
 plaintext={false}
 menubar={false}
/>
{children}
</React.Fragment>)
}